import { base64Image } from '@/constants';
import Image from 'next/image';
const CollageImage = ({ source, unoptimize = true, alt }: { source: string; unoptimize: boolean; alt?: string }) => {
  return (
    <div className="relative top-0 left-0 bottom-0 h-full bg-gray-100">
      <Image
        src={source}
        alt={alt ? alt : 'Banner'}
        fill
        quality={100}
        sizes="10%"
        style={{
          objectFit: 'cover',
          aspectRatio: '540/273',
        }}
        loading="eager"
        blurDataURL={base64Image}
        placeholder="blur"
        unoptimized={unoptimize}
      ></Image>
    </div>
  );
};

export default CollageImage;